__turbopack_context__.v({
  "disabled": "index-module-scss-module__jzH1cW__disabled",
  "radio": "index-module-scss-module__jzH1cW__radio",
});
